module.exports = __webpack_public_path__ + "img/logo_old.de782d23.svg";